<div class="device-info">
  <div class="modal-main px-2 pt-4">
    <div
      class="header d-flex flex-column justify-content-center px-3 pt-2 py-1"
    >
      <div class="d-flex justify-content-between">
        <div class="col-1">
          <img
            src="/assets/svg/ico-chevron-back-outline.svg"
            class="pointer-cursor"
            (click)="navigateBack()"
          />
        </div>

        <ng-container *ngIf="parentType === CONSTANTS.UNIT">
          <div class="col-10">
            <h1 class="modal-title text-center">
              {{ "LOCK_INFO" | translate }}
            </h1>
          </div>
        </ng-container>
        <ng-container *ngIf="parentType === CONSTANTS.ACCESSPOINT">
          <div class="col-10">
            <h1 class="modal-title text-center">
              {{ "DEVICE_INFO" | translate }}
            </h1>
          </div>
        </ng-container>

        <div class="col-1 text-right">
          <img
            src="/assets/svg/ico-hamburger-close.svg"
            class="cross-button pointer-cursor"
            (click)="closeDialog()"
          />
        </div>
      </div>
    </div>
    <div class="container px-2">
      <div class="lock-image row justify-content-center align-items-center">
        <img
          src="/assets/images/DMU-lock.png"
          class="cross-button pointer-cursor"
          *ngIf="deviceKind === CONSTANTS.DMU && parentType !== CONSTANTS.UNIT"
        />
        <img
          src="/assets/images/IPREADER-lock.png"
          class="cross-button pointer-cursor"
          *ngIf="
            deviceKind === CONSTANTS.IPREADER && parentType !== CONSTANTS.UNIT
          "
        />
        <ng-container
          *ngIf="formInstance.imageName.value === CONSTANTS.INTERCONNECT"
        >
          <img
            src="/assets/images/interconnect-lock.png"
            class="cross-button pointer-cursor lock-img"
            *ngIf="parentType === CONSTANTS.UNIT"
          />
        </ng-container>
        <ng-container
          *ngIf="formInstance.imageName.value !== CONSTANTS.INTERCONNECT"
        >
          <img
            src="/assets/images/deadbolt-lock.png"
            class="cross-button pointer-cursor lock-img"
            *ngIf="parentType === CONSTANTS.UNIT"
          />
        </ng-container>
      </div>
      <ng-container *ngIf="parentType === CONSTANTS.UNIT">
        <div class="row d-flex flex-column justify-content-center px-2 pt-4">
          <ng-container
            *ngIf="
              formInstance?.batteryPercentage.value !== null &&
              formInstance?.batteryPercentage?.value >= 0
            "
          >
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">
                {{ "BATTERY_PERCENTAGE" | translate }}
              </p>
              <p class="lock-value">
                {{
                  formInstance?.batteryPercentage?.value +
                    ("PERCENTAGE" | translate)
                }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.deviceType?.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "LOCK_TYPE" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.productType?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.modelNumber.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "MODEL_NUMBER" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.modelNumber?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.serialNumber.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "SERIAL_NUM" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.serialNumber?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.sku.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "SKU" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.sku?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.hardwareVersion.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "HARDWARE_VERISON" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.hardwareVersion?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.hardwareVariant.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "HARDWARE_VARIANT" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.hardwareVariant?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.firmwareVersion.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "FIRMWARE_VERSION" | translate }}</p>
              <p class="lock-value">
                {{ formInstance?.firmwareVersion?.value }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.activationDate?.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "ACTIVATION_DATE" | translate }}</p>
              <p class="lock-value">
                {{
                  formInstance?.activationDate?.value
                    | parsedDateTime : "MM/dd/yyyy"
                }}
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="formInstance?.manufactureDate?.value !== null">
            <div class="row justify-content-between align-items-center">
              <p class="lock-property">{{ "MANUFACTURE_DATE" | translate }}</p>
              <p class="lock-value">
                {{
                  formInstance?.manufactureDate?.value
                    | parsedDateTime : "MM/dd/yyyy"
                }}
              </p>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="parentType === CONSTANTS.ACCESSPOINT">
        <div class="row d-flex flex-column justify-content-center px-2 pt-4">
          <div class="row justify-content-between align-items-center">
            <p class="lock-property">{{ "MAC_ADDRESS" | translate }}</p>
            <p class="lock-value">
              {{
                formInstance?.macAddress.value
                  ? formInstance?.macAddress.value
                  : ("NOT_AVAILABLE" | translate)
              }}
            </p>
          </div>

          <div class="row justify-content-between align-items-center">
            <p class="lock-property">{{ "DEVICE_NAME" | translate }}</p>
            <p class="lock-value">
              {{
                formInstance?.deviceName.value
                  ? formInstance?.deviceName.value
                  : ("NOT_AVAILABLE" | translate)
              }}
            </p>
          </div>

          <div class="row justify-content-between align-items-center">
            <p class="lock-property">{{ "DEVICE_TYPE" | translate }}</p>
            <p class="lock-value">
              {{
                formInstance?.deviceType.value
                  ? (formInstance?.deviceType.value | translate)
                  : ("NOT_AVAILABLE" | translate)
              }}
            </p>
          </div>

          <div class="mt-150">
            <button type="button" class="send-logs-btn px-5 py-3 w-100">
              <strong> {{ "SEND_LOGS_UPPER_CASE" | translate }} </strong>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
